import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
    GET_LOKI_JOBS,
    POST_LOKI_SERVICE_MAPPING,
} from './actionTypes';

import {
    getLokiJobsSuccess,
    getLokiJobsFail,
    postLokiServiceMappingSuccess,
    postLokiServiceMappingFail,
} from './actions';

import { getLokiJobs, postLokiServiceMappingUrl } from "../../helpers/fakebackend_helper";
import {showNotification} from "../../components/Common/notification";

function* onGetLokiJobs() {
    try {
        const response = yield call(getLokiJobs);
        yield put(getLokiJobsSuccess(response));
    } catch (error) {
        yield put(getLokiJobsFail(error));
    }
}

function* onPostLokiServiceMapping({ payload: { service_mapping } }) {
    try {
      const response = yield call(postLokiServiceMappingUrl, service_mapping);
      showNotification('success', 'Service mapping updated successfully');
      yield put(postLokiServiceMappingSuccess(response));
      yield put ({type: GET_LOKI_JOBS});
    } catch (error) {
      showNotification('error', 'Failed to update service mapping');
      yield put(postLokiServiceMappingFail(error.message));
    }
  }

function * lokiSaga() {
    yield takeEvery(GET_LOKI_JOBS, onGetLokiJobs);
    yield takeEvery(POST_LOKI_SERVICE_MAPPING, onPostLokiServiceMapping);
}

export default lokiSaga;